import { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Header from "../components/Header/Header";
import { fetchAitsTestListRequest } from "../../../redux/aits/aitsSlice";
import { getFormatForApi } from "../../../custom_utilities/pyqFormatUtils";
import PaperListing from "../components/Header/PaperListing/PaperListing";
import PyqListing from "../components/Header/PaperListing/PyqListing";

function AitsPage() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { plannerDetails, testDetails, paperName, selectedType } = useSelector(
    (s) => s.examSlice
  );
  const plannerId = plannerDetails?.planner_id;
  const plannerTypeId = plannerDetails?.planner_type_id;
  const paperType = plannerDetails?.id;
  const categoryId = plannerDetails?.category_id;
  const isMistakeBook = String(paperName || "")
    .toLowerCase()
    .includes("mistake book");

  const pyqFormatForApi = getFormatForApi({
    format: testDetails?.format,
    paperName,
    selectedType,
  });

  useLayoutEffect(() => {
    // Mistake Book has its own routes — never stay on empty paper-listing.
    if (isMistakeBook) {
      history.replace("/practice/mistake-book");
      return;
    }

    dispatch(
      fetchAitsTestListRequest({
        paperType: paperType,
        plannerId,
        plannerTestType: plannerTypeId,
        year: testDetails?.year || 2025,
        ...(pyqFormatForApi ? { format: pyqFormatForApi } : {}),
        categoryId: categoryId || "",
      })
    );
  }, [
    dispatch,
    history,
    plannerId,
    plannerTypeId,
    paperType,
    categoryId,
    testDetails?.year,
    pyqFormatForApi,
    isMistakeBook,
  ]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "stretch",
      }}
    >
      <Header />
      {!isMistakeBook &&
        (plannerDetails?.id === 1 ? <PyqListing /> : <PaperListing />)}
    </div>
  );
}

export default AitsPage;
